import { Component } from "@angular/core";
import { ActivatedRouteSnapshot, ActivatedRoute } from "@angular/router";
import { QUERY_PARAMS } from "@tci/common";
import { getAllMenuComponents } from "../ng-shared/ng-util/tools";

export interface ITCITenantNotAvailableParams {
    routeid: string;
    inputid: string;
    component: string;
}

@Component({
    selector: "ng-tenant-not-available",
    templateUrl: "./ng-tenants-not-available.component.html"
})
export class NgTenantsNotAvailableComponent {
    tenant: string;
    component: string;
    component_selector: string;

    constructor(router: ActivatedRoute) {
        this.tenant = router.snapshot.queryParams[QUERY_PARAMS.APP_TYPE];
        this.component = router.snapshot.queryParams[QUERY_PARAMS.COMPONENT];
        if (this.tenant && this.component) {
            const TCIMenuRequestedComp = getAllMenuComponents().find(menuItem => menuItem.getRouteId() === this.component);
            if (TCIMenuRequestedComp) {
                this.component_selector = TCIMenuRequestedComp.getComponentSelectorType().toString();
            }
        }
    }
}
